import { createContext } from "react";

const darkLightModeContext = createContext({ toggleColorMode: () => {} });

export default darkLightModeContext